import React from "react";
import Canvas from "./Canvas";
const DrawingBoard = () => {
  return (
    <div>
      <Canvas />
    </div>
  );
};

export default DrawingBoard;
